import { z } from 'zod';
export const ZodStringToDate = z.coerce.date().transform((dateString, ctx) => {
    const date = new Date(dateString);
    if (!z.date().safeParse(date).success) {
        ctx.addIssue({
            code: z.ZodIssueCode.invalid_date,
        });
    }
    return date;
});
// const ZodStringToDate = z.coerce.date().transform((dateString, ctx) => {
//   const date = new Date(dateString);
//   if (!z.date().safeParse(date).success) {
//     ctx.addIssue({
//       code: z.ZodIssueCode.invalid_date,
//     });
//   }
//   return date;
// });
/**
 * reCAPTCHA Enterprise action names for different routes.
 * These help Google's risk analysis understand the context.
 */
export var RecaptchaAction;
(function (RecaptchaAction) {
    RecaptchaAction["BUSINESS_REGISTRATION"] = "BUSINESS_REGISTRATION";
    RecaptchaAction["BUSINESS_DONATION"] = "BUSINESS_DONATION";
    RecaptchaAction["OWNER_VERIFICATION"] = "OWNER_VERIFICATION";
})(RecaptchaAction || (RecaptchaAction = {}));
